export { default } from './FullPageLoader';
